// extracted by mini-css-extract-plugin
export default {"header":"PaymentHeader_header__u4TmL","amount":"PaymentHeader_amount__BL8Sh","order":"PaymentHeader_order__Yks12","description":"PaymentHeader_description__0IrHl"};